<div class="register-password">
  <div class="row">
    <div [ngClass]="wideResolution ? 'col-12 mt-2' : 'col-12 mt-2'" [innerHTML]="textPasswordPolicies"></div>
    <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-3' : 'col-12 mt-3'">
      <si-generic-alert [showAlert]="errorText"
                        styleClass="error mb-2"
                        [text]="errorText"
      ></si-generic-alert>
      <si-input id="registerPasswordIdentificationPassword"
                name="registerPasswordIdentificationPassword"
                text="SI_PASSWORD"
                placeholder="SI_WRITE_HERE"
                type="password"
                [(model)]="model.password"
                (modelChange)="onChangePassword()"
                rule="generic.fieldNotNull"
      ></si-input>
    </div>
    <div [ngClass]="wideResolution ? 'col-12 col-lg-3 mt-3' : 'col-12 mt-3'">
      <si-input id="registerPasswordIdentificationPasswordConfirm"
                name="registerPasswordIdentificationPasswordConfirm"
                text="SI_PASSWORD_CONFIRMATION"
                placeholder="SI_WRITE_HERE"
                type="password"
                [(model)]="model.passwordConfirm"
                (modelChange)="onChangePasswordConfirm()"
                rule="generic.fieldNotNull"
                [validationExternalErrorText]="validationErrorTextPasswordConfirm"
      ></si-input>
    </div>
  </div>
</div>
